import React from 'react';
import { Link } from 'react-router-dom';

const AboutPageHero = () => {
  return (
    <>
      <section
        className='about-header-section ptb-80 position-relative overflow-hidden bg-dark'
        style={{
          background:
            "url('assets/img/page-header-bg.svg')no-repeat center right",
        }}
      >
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className='section-heading-wrap d-flex justify-content-between z-5 position-relative'>
                <div className='about-content-left'>
                  <div className='about-info'>
                    <h1 className='fw-bold display-5'>
                      Sunlex payment solutions success story with Amazon Web Services
                    </h1>
                    <p className='lead'>
                      Amazon Web Services helps to reduce Infrastructure Costs by 35% and Accelerate Time‑to‑Market by 50%.
                    </p>
                    <p className='lead'>
                      AWS services leveraged: Amazon ECS (Fargate), ElastiCache (Redis), RDS (PostgreSQL), S3, SQS, Lambda, CloudFront, AWS WAF, and KMS
                    </p>
                  </div>
                </div>
                <div className='about-content-right'>
                  <img
                    src='assets/img/pngwingax.png'
                    alt='about'
                    className='img-fluid rounded-custom shadow img-padding'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPageHero;
